var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._l((_vm.spreadsheetsName),function(name){return _c('router-link',{key:name,attrs:{"to":'/form/' + name}},[_vm._v("Vers la commande "+_vm._s(name))])}),_vm._v(" | ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }